import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import * as R from "ramda";
import {Status} from "../../../common/Constants";
import SimpleToggleButton from "../../../../modules/SimpleToggleButton";
import {mapToObjectDDL} from "../../../common/mapper";

class MasterApprovalModifying extends Component {
    levelOptions = [
        {
            label: "0",
            value: 0,
        },
        {
            label: "1",
            value: 1,
        },
        {
            label: "2",
            value: 2,
        },
        {
            label: "3",
            value: 3,
        },
        {
            label: "4",
            value: 4,
        },
        {
            label: "5",
            value: 5,
        },
        {
            label: "6",
            value: 6,
        },
        {
            label: "7",
            value: 7,
        },
        {
            label: "8",
            value: 8,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            dataCabang: [],
            dataLocation: [],
        };
    }

    componentDidMount = async () => {
        let ahassLine = !R.isNil(this.props.initialValues)
            ? mapToObjectDDL(
                this.props.controls.approvalAhassLine.value,
                this.props.controls.approvalAhassLine.value,
            ) : null;
        this.props.setValue("approvalAhassLine", ahassLine);
        let mktLine = !R.isNil(this.props.initialValues)
            ? mapToObjectDDL(
                this.props.controls.approvalMarketingLine.value,
                this.props.controls.approvalMarketingLine.value,
            ) : null;
        this.props.setValue("approvalMarketingLine", mktLine);
        let admLine = !R.isNil(this.props.initialValues)
            ? mapToObjectDDL(
                this.props.controls.approvalAdminLine.value,
                this.props.controls.approvalAdminLine.value,
            ) : null;
        this.props.setValue("approvalAdminLine", admLine);
    }

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Approval"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_approvalId"
                            name="approvalId"
                            label="ID Pelanggaran"
                            readOnly
                            value={this.props.controls.approvalId.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_description"
                            name="approvalDescription"
                            label="Deskripsi"
                            readOnly
                            // mandatory
                            // errorMessage={this.props.errors.approvalDescription}
                            value={this.props.controls.approvalDescription.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <div className="grid grid-3x grid-mobile-none gap-20px margin-bottom-20px">
                            <div id="grid-1">
                                <SimpleDDL
                                    id="input_text_ahas_line"
                                    name="approvalAhassLine"
                                    label="Ahass Line"
                                    box="search"
                                    isClearable
                                    mandatory
                                    errorMessage={this.props.errors.approvalAhassLine}
                                    options={this.levelOptions}
                                    value={this.props.controls.approvalAhassLine.value}
                                    onChange={(value, {name}) =>
                                        this.props.setValue(name, value)
                                    }
                                />
                            </div>
                            <div id="grid-2">
                                <SimpleDDL
                                    id="input_text_mkt_line"
                                    name="approvalMarketingLine"
                                    label="Mkt Line"
                                    box="search"
                                    isClearable
                                    mandatory
                                    errorMessage={this.props.errors.approvalMarketingLine}
                                    options={this.levelOptions}
                                    value={this.props.controls.approvalMarketingLine.value}
                                    onChange={(value, {name}) =>
                                        this.props.setValue(name, value)
                                    }
                                />
                            </div>
                            <div id="grid-3">
                                <SimpleDDL
                                    id="input_text_adm_line"
                                    name="approvalAdminLine"
                                    label="Adm Line"
                                    box="search"
                                    isClearable
                                    mandatory
                                    errorMessage={this.props.errors.approvalAdminLine}
                                    options={this.levelOptions}
                                    value={this.props.controls.approvalAdminLine.value}
                                    onChange={(value, {name}) =>
                                        this.props.setValue(name, value)
                                    }
                                />
                            </div>
                        </div>
                        <SimpleToggleButton
                            id="input_toggle_status"
                            label="Status"
                            value={R.equals(this.props.controls.status.value, Status.ACTIVE)}
                            onToggle={(value) =>
                                this.props.setValue(
                                    "status",
                                    !value ? Status.ACTIVE : Status.INACTIVE
                                )
                            }
                        />

                        <div style={{textAlign: "right"}}>
                            <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                        </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterApprovalModifying);